import React from "react";
import { Col, Form, Input, Row, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { UserServices } from "../../../redux/Services";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { GetLoggedInUser, encryptedData } from "../../../utils";
import { PasswordRule } from "../../../utils/validation";
import LoadingButton from "../../../component/LoadingButton";
import { useAsyncAction } from "../../../hooks/useAsyncAction";

const { Option } = Select;

const ChangePassword = () => {
  const { userId } = useParams();
  let LOG_IN_USER = GetLoggedInUser();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mutateAsync: updatePassword } = useMutation((data) =>
    dispatch(UserServices.updateUserPasswordApi(data, userId, navigate))
  );

  const [handleSubmit, submitting] = useAsyncAction((values) => {
    if (userId) {
      let _data = { ...values };
      // console.log(values);
      _data.UserId = LOG_IN_USER?.UserId;
      _data.OldPassword = encryptedData(values?.OldPassword);
      _data.NewPassword = encryptedData(values?.NewPassword);
      _data.ConfirmPassword = encryptedData(values?.ConfirmPassword);
      return updatePassword(_data);
    }
  });

  return (
    <>
      <div className="p-20">
        <h1>Change Password</h1>
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          autoComplete="off"
          onFinish={handleSubmit}
        >
          <Row gutter={[24, 0]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Old Password"
                name="OldPassword"
                rules={[
                  { required: true, message: "Old Password is required" }
                ]}
              >
                <Input
                  type="password"
                  autoComplete="off"
                  className="form-control"
                  placeholder="New Password"
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="New Password"
                name="NewPassword"
                rules={PasswordRule("New Password")}
              >
                <Input
                  type="password"
                  autoComplete="off"
                  className="form-control"
                  placeholder="New Password"
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Form.Item
                label="Confirm Password"
                name="ConfirmPassword"
                rules={[
                  { required: true, message: "Confirm Password is required" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("NewPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Confirm Password do not match")
                      );
                    }
                  })
                ]}
              >
                <Input
                  type="password"
                  autoComplete="off"
                  className="form-control"
                  placeholder="Confirm Password"
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="text-center">
            <LoadingButton
              key="submit"
              type="submit"
              className="gradient-button w-auto"
              loading={submitting}
            >
              Update Password
            </LoadingButton>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ChangePassword;
